import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {getValueOrDash} from "../../../helpers/defaultReturnFunction";
import { getUser } from "../../../services/authService";

const editableColumns = ["invoiceQty"];

const EditableCell = ({
  value: initialValue,
  row: {index, original},
  column: {id},
  updateLocalState,
}) => {
  const [value, setValue] = useState(initialValue);
  const user = getUser();
  const onChange = (e) => {
    setValue(e.target.value);
    
  };

  const onBlur = () => {
    if (id === "invoiceQty" && value <= original.InvoiceBalQty) {
      if (value) {
        updateLocalState(index, id, value);
        updateLocalState(
          index,
          "bal_qty",
          original.InvoiceBalQty - parseInt(value)
        );
      } else {
        updateLocalState(index, id, 0);
        updateLocalState(index, "bal_qty", original.InvoiceBalQty - 0);
      }
    } else {
      setValue(0);
      updateLocalState(index, id, 0);
      toast.warning("Received quantity can not exceed PO quantity");
    }
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (editableColumns.includes(id)) {
    if (original.InvoiceBalQty === 0 || user?.isSupplierFinance === false) {
      return `${getValueOrDash(value)}`;
    }
    return (
      <input
        className="table-input"
        type="number"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder="Enter Invoice QTY"

        style={{fontSize:"10px", padding:"10px",border:"1px solid #87CEEB"}}
      />
    );
  } else {
    if (id === "bal_qty") {
      if (original.invoiceQty) {
        return `${original.InvoiceBalQty - original.invoiceQty}`;
      } else {
        return `${original.InvoiceBalQty}`;
      }
    }
    return `${getValueOrDash(value)}`;
  }
};

export const editableTableDefaultColumn = {
  Cell: EditableCell,
};
